<template>
    <div>
        <v-progress-circular
            v-if="! enrollments"
            color="primary"
            indeterminate
        ></v-progress-circular>

        <div v-else>
            <create-user-enrollment-dialog
                @enroll="refresh"
                :user="user"
                :existingEnrollments="enrollments"
            ></create-user-enrollment-dialog>

            <v-expansion-panels class="mt-4">
                <v-expansion-panel
                    v-for="(enrollment, idx) in enrollments"
                    :key="idx"
                >
                    <v-expansion-panel-header>
                        {{ enrollment.period.title }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <user-enrollment-information :enrollment="enrollment"></user-enrollment-information>

                        <user-tryouts :user="user" :enrollment="enrollment"></user-tryouts>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import CreateUserEnrollmentDialog from './CreateUserEnrollmentDialog.vue'
import UserEnrollmentInformation from './UserEnrollmentInformation.vue'
import UserTryouts from './UserTryouts.vue'

export default {
    props: {
        user: {
            type: Object,
        }
    },

    components: {
        UserEnrollmentInformation,
        UserTryouts,
        CreateUserEnrollmentDialog,
    },

    data: () => ({
        enrollments: null
    }),

    methods: {
        async refresh() {
            const response = await this.$apiv2.get(`user/${this.user.id}/enrollment`)
            this.enrollments = response.data.enrollments
            this.enrollments.reverse()
        },

        reset() {
            this.enrollments = null
        }
    },
}
</script>
